import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0de10954"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "module-title"
};
const _hoisted_3 = {
  class: "border-box"
};
const _hoisted_4 = {
  class: "data-list"
};
const _hoisted_5 = ["href", "target"];
const _hoisted_6 = {
  class: "left"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "right"
};
const _hoisted_9 = {
  class: "num"
};
const _hoisted_10 = {
  class: "name text-overflow"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "wrapper",
    style: _normalizeStyle({
      backgroundColor: $props.menu.backColor ? $props.menu.backColor : '',
      backgroundImage: $props.menu.backImage ? `url(${$props.menu.backImage})` : ''
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.menu.module_name), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataList, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      class: "data-card",
      key: item.id,
      href: item.targetUrl ? item.targetUrl : 'javascript:void(0)',
      target: item.targetUrl ? '_blank' : '_self'
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
      src: require(`@/assets/images/dataDisplay/icon${index % 20 + 1}.png`),
      alt: ""
    }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$utils.toThousands(item.num)), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1)])], 8, _hoisted_5);
  }), 128))])])])], 4);
}